import { render } from "./TrucksManager.vue?vue&type=template&id=f81acce4&lang=pug"
import script from "./TrucksManager.vue?vue&type=script&lang=ts"
export * from "./TrucksManager.vue?vue&type=script&lang=ts"
script.render = render

export default script